export const en = {
    selected_tariff: 'Selected tariff',
    continue: 'Continue',
    group_trip_info: 'Go to the selection of application participants, you need to add this service',
    tariff: 'Your tariff',
    person_trip_info: 'Go to the personal application page',
};
